import { render, staticRenderFns } from "./SelecaoLeito.vue?vue&type=template&id=04f6c2e4&"
import script from "./SelecaoLeito.vue?vue&type=script&lang=js&"
export * from "./SelecaoLeito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports